import axios from 'axios';

export const state = {
  account: {},
  accounts: [],
};

export const mutations = {
  setAccount(context, payload) {
    context.account = payload;
  },
  updateAccounts(context, payload) {
    context.accounts.push(payload);
  },
  resetAccounts(context) {
    context.accounts = [];
  },
};

export const getters = {
  account(context) {
    return context.account;
  },
  accounts(context) {
    return context.accounts;
  },
};

export const actions = {
  async createAccount(context, data) {
    data.application_client_id = context.rootState.userStore.user.application_client_id;

    return axios
      .post(`${window.BASE_API.PAYMENT}/api/accounts`, data)
      .catch(error => Promise.reject(error));
  },
  async updateAccount(context, data) {
    data.application_client_id = context.rootState.userStore.user.application_client_id;

    return axios
      .put(`${window.BASE_API.PAYMENT}/api/accounts/${data.id}`, data)
      .catch(error => Promise.reject(error));
  },
  async refreshAccount(context, data) {
    data.application_client_id = context.rootState.userStore.user.application_client_id;

    return axios
      .post(`${window.BASE_API.PAYMENT}/api/accounts/${data.id}/refresh`, data)
      .then(resp => resp.data)
      .catch(error => Promise.reject(error));
  },
  async deleteAccount(context, data) {
    data.application_client_id = context.rootState.userStore.user.application_client_id;

    return axios
      .delete(`${window.BASE_API.PAYMENT}/api/accounts/${data.id}`)
      .catch(error => Promise.reject(error));
  },
  async getAccount(context, accountId) {
    return axios
      .get(`${window.BASE_API.PAYMENT}/api/accounts/${accountId}`)
      .then((response) => {
        context.commit('setAccount', response.data.data);

        return response.data.data;
      });
  },
};

export default {
  state,
  actions,
  getters,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/accounts/accountsStore.js